<template>
  <div class="pipeline-builder-view">
    <div v-if="pipelineId" class="edit-notice-banner">
      <InfoIcon :size="16" />
      <span>Editing existing pipelines is not yet supported — changes will not be saved to the server.</span>
    </div>
    <PipelineCanvas
      :pipeline-id="pipelineId"
      :initial-pipeline="initialPipeline"
      :available-connections="availableConnections"
      :save-disabled="!!pipelineId"
      @save="handleSavePipeline"
      @update-name="handleUpdateName"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Info as InfoIcon } from 'lucide-vue-next'
import PipelineCanvas from '@/Modules/ETL/components/pipeline/PipelineCanvas.vue'
import { useNotification } from '@/Modules/ETL/composables/useNotification'
import apiService from '@/Modules/ETL/services/api'

const route = useRoute()
const router = useRouter()
const { error: notifyError } = useNotification()

const pipelineId = ref(route.params.id)
const initialPipeline = ref(undefined)
const availableConnections = ref([])

onMounted(async () => {
  await loadConnections()

  if (pipelineId.value) {
    await loadPipeline()
  }
})

const loadConnections = async () => {
  try {
    const response = await apiService.retrieveUserConnections()
    availableConnections.value = response.data
  } catch (err) {
    console.error('Failed to load connections:', err)
  }
}

const loadPipeline = async () => {
  try {
    const response = await apiService.getPipeline(pipelineId.value)
    initialPipeline.value = response.data
  } catch (err) {
    console.error('Failed to load pipeline:', err)
  }
}

const handleSavePipeline = async (pipelineData) => {
  if (pipelineId.value) {
    // Backend update not implemented yet — banner already informs the user
    return
  }

  try {
    const response = await apiService.createDataPipeline(pipelineData)
    pipelineId.value = response.data.id
    router.push(`/ETL/pipelines/${response.data.id}/edit`)
  } catch (err) {
    const errorMessage = err && typeof err === 'object' && 'errorMessage' in err
      ? err.errorMessage
      : err?.message || 'Unknown error'
    notifyError('Save Failed', errorMessage)
  }
}

const handleUpdateName = (name) => {
  console.log('Pipeline name updated:', name)
}
</script>

<style scoped>
.pipeline-builder-view {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.edit-notice-banner {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 1.25rem;
  background: var(--color-warning-bg);
  color: var(--color-warning);
  font-size: 13px;
  font-weight: 500;
  border-bottom: 1px solid var(--color-warning-light);
  flex-shrink: 0;
}
</style>
